module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/bed-45611d783cdd2463c144cef1cdeed649.svg";